import { Group } from "@mantine/core";
import MantineImage from "../mantine/image";
import adminicon from "../../assets/images/adminicon.png";
import ArrowDown from "../../assets/svg/chevron-down";
import { useNavigate, useParams } from 'react-router-dom';
//import { useRouter } from "next/router";
import HeaderuserProfileIcon from "./HeaderUserIcon";
import { useStateContext } from "../../Contexts/ContextProvider";
import { LocalGetUser } from "../..//helpers/storagehelper";
import { useDisclosure } from "@mantine/hooks";
import { useEffect, useState } from "react";
import MantineText from "../mantine/text";
import MantineFlex from "../mantine/flex";
import MantineButton from "../mantine/button";
import { IconBuilding, IconChevronDown, IconChevronUp, IconLogout, IconMenu2, IconReportMoney, IconUser } from "@tabler/icons-react";
import { MantineMenu, MantineMenuDropdown, MantineMenuItem, MantineMenuTarget } from "../mantine/menu";
import { Logo, useCurrentUrl, useCustomMediaQuery } from "../../helpers/common";
import { themeColors, verticalMenus, verticalMenusUsers } from "../../helpers/constant";
import { MantineModal } from "../mantine/modal";
import CustomModalHeaderTitle from "../common/customModalHeaderTitle";
import MantineIcons from "../mantine/icons";
import MantinePaper from "../mantine/paper";
import MantineDivider from "../mantine/divider";
import { Link } from "react-router-dom";
import LogoutConfirmation from "../../pages/logoutConfirm";

const Header = () => {
  const { currentPrimaryColor } = useStateContext();
  const navigate = useNavigate();
  const currentUrl = useCurrentUrl();
  const [iconRole, SetIconRole] = useState<any>(null)
  const { isSmallScreen, } = useCustomMediaQuery(); // media query in mantine(smallscreen ==> max-width: 640px), (isMediumScreen ==> (min-width: 641px) and (max-width: 1024px)), (isLargeScreen ==> (min-width: 1025px))
  const [mobileResponsiveOpenDrawer, setMobileResponsiveOpenDrawer] = useState<any>(false)
  const [open, setOpen] = useState<any>(false);
  const [activeSubMenu, setActiveSubMenu] = useState<any>(null);
  const [OpenedLogoutPopUp, { open: OpenLogoutPopUp, close: closeLogoutPopUp }] = useDisclosure(false);

  const handleMenuPress = () => {
    //router.push('/profile');
    navigate('/profile');
  }
  const handleChangePassword = () => {
    //   router.push('/changepassword');
    navigate('/changepassword');
  }

  const userRoleId = localStorage.getItem("userRoleId");

  useEffect(() => {
    const user = LocalGetUser();
    if (user) {
      const role = user.userRoleName;
      SetIconRole(role || '');
    }
  }, [LocalGetUser()])

  const handleMenuUser = () => {
    //router.push('/manageuser');
    navigate('/manageuser');
  }
  const handleMangeLogs = () => {
    //router.push('/managelogs');
    navigate('/managelogs');
  }
  const handleMenuInventory = () => {
    //router.push('/inventory');
    navigate('/inventory');
  }
  const handleMenuSales = () => {
    //router.push('/sales');
    navigate('/sales');
  }

  const handleColorfilterImage = themeColors?.filter((el: any) => el.color == currentPrimaryColor)[0];

  const handleNavigationRoute = (routes: any) => {
    if (routes == "/logout") {
      localStorage.removeItem("authUser");
      localStorage.removeItem("authUsers");
      localStorage.removeItem("token");
      localStorage.removeItem("userid");
      //router.push("/login");
      navigate('/');
    } else {
      //router.push(`${routes}`);
      navigate(`${routes}`);
    }
  };

  const toggleSubMenu = (index: any) => {
    setActiveSubMenu(activeSubMenu === index ? null : index);
  };
  const navigateToPage = () => {
    if (userRoleId === '1') {
      return '/manageuser';
    } else if (userRoleId === '2') {
      return '/client';
    }
    return '/';
  };
  //const hideLinksForPaths = ['/manuals', '/changerequests', '/drawings'];


  return (
    <>
      {/* <Group className="bg-white pb-0 sticky top-0 z-50">
        <Group className={`w-full mx-auto py-3 flex items-center justify-between ${isSmallScreen ? 'max-w-full px-4 ' : 'max-w-[85%]'} bg-white`}>
          <MantineFlex gap={20}>
            <MantineImage
              src={Logo}
              alt=""
              className={"rounded-circle"}
              height={isSmallScreen ? '40' : '50'}
              width={isSmallScreen ? '40' : '50'}
              style={{ filter: handleColorfilterImage?.filter }}
            />
            {isSmallScreen && <MantineIcons
              onClick={() => setMobileResponsiveOpenDrawer(!mobileResponsiveOpenDrawer)}
              iconComponent={IconMenu2}
              size={26}
              color={currentPrimaryColor}
              variant="transparent"
              stroke={1}
            />}
          </MantineFlex>
          <HeaderuserProfileIcon handleMenuPress={handleMenuPress} handleChangePassword={handleChangePassword} handleLogout={handleLogout} isSmallScreen={isSmallScreen} />
        </Group>
      </Group> */}
      {/* mobile screen down side open concept  start */}
      {isSmallScreen &&
        <div className="mb-6 sticky top-[3.8rem] z-[1]">
          {mobileResponsiveOpenDrawer &&
            <>
              <MantineDivider my="" />
              <MantinePaper p={10}>
                <div>
                  {(iconRole == "Admin" ? verticalMenus : verticalMenusUsers)?.map((menus: any, index: any) => (
                    <div key={index} className="">
                      <MantineFlex onClick={() => toggleSubMenu(index)}>
                        <MantineButton variant="transparent" justify={"start"}
                          leftSection=
                          {
                            <MantineIcons iconComponent={menus.src} size={22} className={`text-current ${open === menus.id && 'text-current-secondary-color'} ${iconRole === "Admin" ?
                              menus?.menusLink?.find((el: any) => el.route === currentUrl) ? "!text-current-primary-color" : "" : menus.route === currentUrl && "text-current-secondary-color"
                              }`} variant={"transparent"} />
                          }
                          onClick={() => iconRole != "Admin" ? handleNavigationRoute(menus?.route) : {}}
                          className={`text-[#40454C] ${!open && '!pl-0'} ${iconRole === "Admin" ?
                            menus?.menusLink?.find((el: any) => el.route === currentUrl) ? "!text-current-primary-color" : "" : menus.route === currentUrl && "text-current-secondary-color"
                            }`}
                        >{menus.title}</MantineButton>
                        {!open && menus?.menusLink &&
                          <MantineIcons
                            iconComponent={activeSubMenu === index ? IconChevronUp : IconChevronDown}
                            size={20}
                            className={`${menus?.menusLink?.find((el: any) => el.route === currentUrl) ? "text-current-primary-color" : "text-current"}`}
                            variant="transparent"
                            stroke={1.5}
                            style={{ transition: "transform 200ms ease" }}
                          />
                        }
                      </MantineFlex>
                      {activeSubMenu === index &&
                        <div className="">
                          {menus?.menusLink?.map((subMenus: any, index: any) => (
                            <div key={index} className={`text-current text-[13px] py-2 ml-6 pl-6 cursor-pointer hover:text-current-secondary-color ${subMenus?.route == currentUrl && '!text-current-secondary-color'}`} onClick={() => handleNavigationRoute(subMenus?.route)}>{subMenus?.name}</div>
                          ))}
                        </div>
                      }
                    </div>
                  ))}
                </div>
              </MantinePaper>
            </>
          }
        </div>
      }
      {/* mobile screen down side open concept  end */}
      {!isSmallScreen &&
        <Group className={`w-full text-sm sticky top-0 z-10`} style={{ background: currentPrimaryColor }}>
          <Group className="w-full mx-auto max-w-[98%] h-[49px]">
            <MantineFlex className="w-full ml-4 justify-between" gap={30}>
              <Group className="flex-1">
                <Link to={navigateToPage()}>
                  <MantineImage
                    src={Logo}
                    alt=""
                    className={"rounded-circle"}
                    height={isSmallScreen ? '40' : '50'}
                    width={isSmallScreen ? '40' : '165'}
                    style={{ filter: handleColorfilterImage?.filter }}
                  />
                </Link>
                {userRoleId === '1' && (
                  <>
                    <Link to="/manageuser">
                      <MantineText className="text-white cursor-pointer flex items-center">
                        <IconBuilding size={16} className="mt-1 mr-2" /> <div className="text-sm mt-1">Users</div>
                      </MantineText>
                    </Link>
                    <Link to="/manageclients">
                      <MantineText className="text-white cursor-pointer flex items-center">
                        <IconBuilding size={16} className="mt-1 mr-2" /> <div className="text-sm mt-1">Clients</div>
                      </MantineText>
                    </Link>
                  </>
                )}
              </Group>
              {/* <Group className="flex-1 justify-center">
                <MantineText className="text-white cursor-pointer flex items-center" onClick={handleMenuInventory}>
                  <IconBuilding size={16} className="mt-1 mr-2" /> <div className="text-sm mt-1">Inventory</div>
                </MantineText>
              </Group> */}
              <Group className="flex-1 justify-end">
                <MantineText className="text-white cursor-pointer flex items-center" onClick={handleMenuPress}>
                  <IconUser size={16} className="mt-1 mr-2" /> <div className="text-sm mt-1">My Account</div>
                </MantineText>

                <MantineText
                  className="text-white cursor-pointer flex items-center" onClick={OpenLogoutPopUp}  >
                  <IconLogout size={16} className="mt-1 mr-2" /> <div className="text-sm mt-1">Logout</div>
                </MantineText>

                <MantineModal opened={OpenedLogoutPopUp} onClose={closeLogoutPopUp} title={<CustomModalHeaderTitle title="Logout" onClick={closeLogoutPopUp} />} >
                  <LogoutConfirmation
                    modalclose={closeLogoutPopUp}
                    currentPrimaryColor={currentPrimaryColor}
                  />
                </MantineModal>

              </Group>
            </MantineFlex>

          </Group>
        </Group>
      }
    </>
  );
};

export default Header;

